import React from 'react';
import {createRoot} from "react-dom/client";

import {Provider} from 'react-redux'
import {store} from './redux/store';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//auth -----------------------
import {mostrarPerfil} from './redux/reducers/authReducer';
import Strings from "./assets/strings";
import {getLSLang} from "./helpers";
import {getIdToken} from "./services/auth";
//end auth -----------------------






//import * as serviceWorker from './serviceWorker';


if(getIdToken()) {
    store.dispatch(mostrarPerfil()); // to get the color en currency
}
//setear idioma
let lang = getLSLang("l");
Strings.setLanguage(lang);

if (!Object.entries) {
    Object.entries = function( obj:any ){
        let ownProps = Object.keys( obj ),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}


const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
        <Provider store={store}>
         {/*<React.StrictMode>*/}
         {/*   <FirebaseAppProvider firebaseConfig={ firebaseConfig.config }>*/}
         {/*       <Suspense fallback={<p>Cargando...</p>}>*/}
                    <App />
                {/*</Suspense>*/}
            {/*</FirebaseAppProvider>*/}
        {/*</React.StrictMode>*/}
        </Provider>
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();



